import { AppBar, Grid, Tab, Tabs } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Fragment, useContext, useEffect } from 'react';
import { useFlags, useAllowedNavRoutes } from '../../../hooks';
import { Page, PageTitle, ExternalLinkPortalCard, LinkPortalCard } from '../../../components';
import { AdminContext, UserContext } from '../../../context';
import { adminLandingLinks, filterNavLinksForAccess } from '../../../helpers';

export const AdminLanding = () => {
  const classes = useStyles();
  const featureFlags = useFlags();
  const userContext = useContext(UserContext);
  const { user } = userContext;
  const { availableLinks } = useAllowedNavRoutes(featureFlags, user);

  const { selectedAdminTab, setSelectedAdminTab } = useContext(AdminContext);

  useEffect(() => {
    // set the first tab as the default selected tab on page load
    const tabs = filterNavLinksForAccess(
      adminLandingLinks,
      userContext,
      featureFlags,
      availableLinks
    );
    if (tabs?.length === 1) {
      setSelectedAdminTab(tabs[0].name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminLandingLinks, userContext, featureFlags]);

  useEffect(() => {
    // reset the tabs to the first one when FF turn off/on so you aren't stuck on a tab when the flag is off
    setSelectedAdminTab('Manage Tools');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title="Admin Home" showSideBar={false} sideBarLinks={[]}>
      <PageTitle title="Admin Home" />
      <AppBar position="static" color="default" component="div" className={classes.tabBar}>
        <Tabs
          value={selectedAdminTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={(_, value) => {
            setSelectedAdminTab(value);
          }}
        >
          {filterNavLinksForAccess(
            adminLandingLinks,
            userContext,
            featureFlags,
            availableLinks
          ).map((link, index) => {
            return (
              <Tab
                key={`${index}`}
                id={link.name}
                value={link.name}
                aria-controls={link.name}
                label={link.name}
              />
            );
          })}
        </Tabs>
      </AppBar>
      <Grid spacing={2} container alignItems="center" className={classes.wrapper}>
        {filterNavLinksForAccess(
          adminLandingLinks.find(link => link?.name === selectedAdminTab)?.links,
          userContext,
          featureFlags,
          availableLinks
        ).map((link, i) => {
          const hasLegacyLink = link.legacyUrl && !link.url ? true : false;
          const hasLegacyLinkWithFFOff =
            link.featureFlag && link.legacyUrl && !featureFlags[link.featureFlag] ? true : false;
          return (
            <Fragment key={`${i}`}>
              <Grid xs={12} sm={6} md={4} item>
                {hasLegacyLink || hasLegacyLinkWithFFOff ? (
                  <ExternalLinkPortalCard link={link} />
                ) : (
                  <LinkPortalCard link={link} />
                )}
              </Grid>
            </Fragment>
          );
        })}
      </Grid>
    </Page>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    marginTop: '0',
    paddingBottom: '1rem'
  },
  tabBar: {
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.grey[400]}`
  }
}));
